import React from 'react';
import styled from 'styled-components';
import {
  RecentArticles as IProps,
} from 'src/infrastructure/gatsby/types/recent-articles';
import RecentList from '@shipae/components-sandbox/component/recent-list';
import RecentListTheme
  from '@shipae/components-sandbox/component/recent-list/theme';
import GatsbyImage from 'gatsby-image';
import {
  StrapiArticles,
} from 'src/infrastructure/gatsby/types/strapi-articles';
import SmartLink from 'components/smart-link';

const RecentArticles: React.FC<IProps & StrapiArticles> = ({
  ...content
}) => (
  <RecentList
    title={content.title}
    linkLabel={content.viewAllLabel}
    linkTo={content.viewAllUrl}
    linkComponent={SmartLink}
    entries={
      content.edges.slice(0, content.listSize || 5)
        .map(({ node: { articleSettings: item } }) => (
          {
            image: (
              item.image?.localFile?.childImageSharp?.fluid
                ? (
                  <GatsbyImage
                    fluid={item.image?.localFile?.childImageSharp?.fluid}
                    alt={item.image?.alternativeText || ''}
                  />
                )
                : null
            ),
            linkLabel: item.title,
            linkTo: `${ content.articleUrlPrefix || '/news/' }${ item.slug }/`,
          }
        ))
    }
    theme={{
      ...RecentListTheme,
      Main: styled(RecentListTheme.Main)`
        width: auto;
      `,
    }}
  />
);

export default RecentArticles;
